import Page from '@admin/components/page'
import Enrollments from './enrollments'
import Performance from './performance'
import Overview from './overview'
import Emails from './emails'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.sms_campaign.title,
  manager: {
    path: `/admin/campaigns/sms/${resources.sms_campaign.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview sms_campaign={ resources.sms_campaign } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design sms_campaign={ resources.sms_campaign } />
      },
      {
        label: 't(Emails)',
        path: '/emails',
        panel: <Emails sms_campaign={ resources.sms_campaign }  />
      },
      {
        label: 't(Enrollments)',
        path: '/enrollments',
        panel: <Enrollments sms_campaign={ resources.sms_campaign }  />
      },
      {
        label: 't(Performance)',
        path: '/performance',
        panel: <Performance sms_campaign={ resources.sms_campaign }  />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  sms_campaign: `/api/admin/campaigns/sms/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
